import React, { Component } from 'react';
import twitterlogo from '../images/Twitter_Social_Icon_Rounded_Square_Color.png';

export default class Contact extends React.Component {
    render() {
      return (
        <div className="App-Body">
              <header className="App-header">
              </header>
              <div className="VBWhite">
              
              <img src={twitterlogo} className="App-logo-sm" alt="mvplogo" />

                <div><p>If you'd like to contact us send us a direct twitter message <a href="https://twitter.com/vanstone_bailey">@vanstone_bailey</a> </p>
                </div>
              </div>
              <div className="VBInverse">
                <div>
                <p>You can contact Steve directly via his <a href="https://www.linkedin.com/in/steve-spencer-9331024/" className="VBInverse">linkedIn profile</a> or direct message him on Twitter <a href="https://twitter.com/sdspencer" className="VBInverse">@sdspencer</a>
                </p>
                  </div>
                </div>
              </div>);
          
    }
  }